import { useRecoilValue } from 'recoil';

import { contractCheckoutAtom } from './atom';

export default function useContractCheckoutData() {
  return useRecoilValue(contractCheckoutAtom);
}
